export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

export const GET_URL_WEBSSO_LOGIN = 'GET_URL_WEBSSO_LOGIN';
export const GET_URL_WEBSSO_LOGIN_SUCCESS = 'GET_URL_WEBSSO_LOGIN_SUCCESS';
export const GET_URL_WEBSSO_LOGIN_FAIL = 'GET_URL_WEBSSO_LOGIN_FAIL';

export const GET_URL_WEBSSO_LOGOUT = 'GET_URL_WEBSSO_LOGOUT';
export const GET_URL_WEBSSO_LOGOUT_SUCCESS = 'GET_URL_WEBSSO_LOGOUT_SUCCESS';
export const GET_URL_WEBSSO_LOGOUT_FAIL = 'GET_URL_WEBSSO_LOGOUT_FAIL';
